import * as React from 'react';
import { addClass, Bem } from '../../utils/css.js';
import '../../constants.js';
import { useId } from '../../utils/hooks/useId.js';
import './StrengthAdornment.scss.js';

const defaultStrengthStrings = {
  short: "Too Short",
  weak: "Weak",
  fair: "Fair",
  good: "Good",
  strong: "Strong"
};
const bem = Bem.create("vai-strength-adornment");
const StrengthAdornment = React.forwardRef((props, ref) => {
  const { htmlId, dataTa = "vai-strength-adornment", strength, strengthStrings = defaultStrengthStrings, className, ...rest } = props;
  const id = useId(htmlId, ["strength-adornment"]);
  return strength && strengthStrings && strengthStrings[strength] ? /* @__PURE__ */ React.createElement("div", {
    id: id.toString(),
    "data-ta": dataTa,
    className: addClass(bem.block(strength), className),
    ref,
    ...rest
  }, strengthStrings[strength]) : null;
});

export { StrengthAdornment };
